import { useMsal } from '@azure/msal-react';
import classes from './login-stage-one.module.scss';

import {
  Box,
  Card,
  CardHeader,
  CardActions,
  CardContent,
  Divider,
  Link,
  Button,
} from '@mui/material';

import {
  CcfTypography,
  CcfButton,
  useTranslator,
  CcfTextField,
} from '@nice-ccf/ui-controls';

export interface LoginStageOneProps {
  onUserNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error: {
    message: string;
    status: boolean;
  };
  currentusername: string;
  checkUserNameAndNavigate: (e: React.FormEvent<HTMLFormElement>) => void;
}

/**
 * Component for login stage one (check user name and navigate)
 * @param props - LoginStageOneProps
 * @example <LoginStageOne />
 * @returns
 */
export function LoginStageOne(props: LoginStageOneProps) {
  const { onUserNameChange, checkUserNameAndNavigate, error, currentusername } =
    props;
  const [translate] = useTranslator();
  const signInHeader = translate('signInHeader');
  const userName = translate('userName');
  const { instance } = useMsal();
  const currentURL = window.location.href;
  const agentDemoTestURL = 'https://d1s74gzjhz7gu0.cloudfront.net/home';
  const agentDemoProdURL = 'https://d1u959wi0vug3n.cloudfront.net/home';
  const isTestEnvironment = currentURL === agentDemoTestURL;
  const isProdEnvironment = currentURL === agentDemoProdURL;
  const loginRequest = {
    scopes: ['openid', 'profile', 'email'],
    redirectUri: isTestEnvironment
      ? agentDemoTestURL
      : isProdEnvironment
      ? agentDemoProdURL
      : currentURL,
  };

  /**
   * Component for login stage two (check password and navigate)
   * @param props - LoginStageOneProps
   * @example <LoginStageOne />
   * @returns
   */
  const handleSSOLogin = () => {
    instance.loginRedirect(loginRequest).catch((e: any) => {
      console.log(e);
    });
  };
  return (
    <Box boxShadow={1}>
      <Card elevation={0} className={classes.stageOneCard}>
        <CardHeader
          title={signInHeader}
          classes={{ title: classes.title, root: classes.header }}
        />
        <Divider />
        <form onSubmit={checkUserNameAndNavigate}>
          <CardContent className={classes.content}>
            <CcfTextField
              id="userName"
              placeholder={userName}
              size="small"
              variant="outlined"
              fullWidth={true}
              value={currentusername}
              onChange={onUserNameChange}
              helperText={error.status && error.message}
              error={error.status}
            />
          </CardContent>
          <CardActions className={classes.actions}>
            <CcfButton
              type="submit"
              variant="contained"
              color="primary"
              disabled={currentusername.length > 0 ? false : true}
              fullWidth={true}
              className={
                currentusername.length === 0
                  ? classes.nextButtonDisabledStyle
                  : classes.nextButtonStyling
              }
            >
              <CcfTypography translationKey="next" />
            </CcfButton>
            <CcfTypography translationKey={'or'}></CcfTypography>
            <Button
              type="button"
              variant="contained"
              color="primary"
              fullWidth={true}
              className={classes.primaryButtonStyling}
              onClick={handleSSOLogin}
            >
              <CcfTypography translationKey="ssoLogin"></CcfTypography>
            </Button>
          </CardActions>
        </form>
        <Box mt={2}>
          <Link>
            <CcfTypography
              style={{ cursor: 'pointer' }}
              translationKey="loginStageOneLink"
            />
          </Link>
        </Box>
      </Card>
    </Box>
  );
}

export default LoginStageOne;
